import { User } from '@mi-front/core';
import { BreadcrumbItem } from '@mi-front/ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Page } from '../../../../../components/page/Page';

interface Props {
  readonly title?: React.ReactNode;
  readonly active?: User;
  readonly activeText?: React.ReactNode;
}

export const UsersBreadcrumbs = (_p: Props) => {
  const items: BreadcrumbItem[] = [];

  return (
    <Page.Breadcrumbs
      items={[
        {
          content: <FormattedMessage id="admin.users.title" defaultMessage="Usuarios" />,
          href: '/admin/users',
        },
        ...items,
      ]}
    />
  );
};
